/**
 * Avatar constants
 */
export const allowedFormats = ['png', 'jpeg', 'jpg'];
export const avatarMaxSize = 2 * 1024 * 1024;
